import Head from 'next/head';
import { useRouter } from 'next/router';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { AuthTransition } from '@/Module/Auth/Component';
import { LINKS } from '@/Module/Core/Constant';
import type { IVerifyPaymentScript } from '@/Module/Subscription/Model/ApiModel';
const ScriptContainer: FC<IVerifyPaymentScript> = props => {
  const [isPush, setIsPush] = useState(true);
  const router = useRouter();
  useEffect(() => {
    window.dataLayer?.forEach(tag => {
      if ((tag as any).event === 'purchase') setIsPush(false);
    });
    const pushTimer = setTimeout(() => {
      const query = props?.mciCouponInfo?.code ? {
        code: props.mciCouponInfo.code,
        orderId: props.orderId
      } : {
        orderId: props.orderId
      };
      router.replace({
        pathname: LINKS.SUBSCRIPTION.BUY_SUCCESS,
        query
      });
    }, 200);
    return () => {
      clearTimeout(pushTimer);
    };
  }, [props]);
  useEffect(() => {
    if (isPush && window.dataLayer) {
      window.dataLayer.push({
        event: 'purchase',
        ecommerce: {
          currency: 'TRY',
          transaction_id: props.orderId,
          value: props.amount,
          // the value user paid
          coupon: props.discountCode,
          coupon_discount: props.discountAmount * 10,
          // the discount user received
          items: [{
            item_name: props.subscriptionPlan,
            item_variant: props.subscriptionType,
            // the plan discount:
            discount: props.subscriptionPlanOriginalPrice > 0 ? (props.subscriptionPlanOriginalPrice - props.subscriptionPlanPrice) * 10 : 0,
            // the plan price:
            price: props.subscriptionPlanOriginalPrice > 0 ? props.subscriptionPlanOriginalPrice * 10 : props.subscriptionPlanPrice * 10
          }]
        }
      });
    }
  }, [isPush, props]);
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="ScriptContainer.tsx">
        <title>پرداخت موفق</title>
      </Head>
      <AuthTransition data-sentry-element="AuthTransition" data-sentry-source-file="ScriptContainer.tsx" />
    </>;
};
export default ScriptContainer;